/** Classe CSS (st-leg-*) com as cores de status do sistema legado. */
export function statusLegadoClass(status: string | null | undefined): string {
  const s = (status || '').toUpperCase().trim();
  if (s === 'CANCELADO') return 'st-leg-cancelado';
  if (s === 'COMPRADO') return 'st-leg-comprado';
  if (s === 'AUTORIZADO') return 'st-leg-autorizado';
  if (s === 'PARCIAL') return 'st-leg-parcial';
  return 'st-leg-outro'; // ABERTO e demais: sem cor
}
